'use strict';

angular.module('amexReconciliationApp')
  .service('TransactionSearchModel', function (ModelFactory,
                                               UserModel,
                                               roles,
                                               urls,
                                               $rootScope) {
    var filterModel = ModelFactory.create('TransactionSearchModel', [
      'params',
      'billingCycle'
    ]);

    filterModel.params({});

    filterModel.role = function (newRole) {
      var currentRole = _.get(filterModel.params(), 'role');

      if (arguments.length && !_.isEqual(newRole, currentRole)) {
        var newParams = _.assign(
          {role: newRole, filter: 'all'},
          defaultParamsForRole(newRole)
        );
        filterModel.params(newParams);
        return newRole;
      } else {
        return currentRole;
      }
    };

    UserModel.onCurrentUserChanged($rootScope, function (newUser) {
      var roles = _.get(newUser, 'roles', []);
      var defaultRole = _.head(roles);

      filterModel.role(defaultRole);
    });

      paramGetterSetter(filterModel, 'card');
      paramGetterSetter(filterModel, 'bca');
      paramGetterSetter(filterModel, 'accountingLine');
      paramGetterSetter(filterModel, 'bta');

    filterModel.roleName = function () {
      return _.get(filterModel.params(), ['role', 'name'], '');
    };

    filterModel.isBcaManager = function () {
      return filterModel.roleName() === roles.BCA_MANAGER ||
        filterModel.roleName() === roles.LIMITED_BCA_MANAGER;
    };

    filterModel.isCardMember = function () {
      return filterModel.roleName() === roles.CARDMEMBER ||
        filterModel.roleName() === roles.LIMITED_CARDMEMBER;
    };

    filterModel.isCardManager = function () {
      return filterModel.roleName() === roles.CARD_MANAGER ||
        filterModel.roleName() === roles.LIMITED_CARD_MANAGER;
    };

    filterModel.isAccountingManager = function () {
      return filterModel.roleName() === roles.ACCOUNTING_MANAGER ||
        filterModel.roleName() === roles.LIMITED_ACCOUNTING_MANAGER;
    };
    // for Bta Manager
      filterModel.isBtaManager = function () {
          return filterModel.roleName() == roles.BTA_MANAGER;
      };

    filterModel.isLimitedRole = function () {
      return _.includes([
        roles.LIMITED_CARDMEMBER,
        roles.LIMITED_CARD_MANAGER,
        roles.LIMITED_BCA_MANAGER,
        roles.LIMITED_ACCOUNTING_MANAGER
      ], filterModel.roleName());
    };

    filterModel.account = function () {
      return filterModel.bca() || filterModel.accountingLine() || filterModel.card() || filterModel.bta();
    };

    filterModel.siteNumber = function () {
      return _.get(filterModel.account(), 'siteNumber');
    };

    filterModel.queryParams = function () {
      var queryParams = {};

      var endDate = _.get(filterModel.billingCycle(), 'endDate');
      if (endDate) {
        queryParams.endDate = endDate;
      }

      var startDate = _.get(filterModel.billingCycle(), 'startDate');
      if (startDate) {
        queryParams.startDate = startDate;
      }

      if (filterModel.isBcaManager()) {
        var bca = filterModel.bca();
        queryParams.rca = bca.rca;
        queryParams.bca = bca.bca;
        queryParams.siteNumber = bca.siteNumber;
      } else if (filterModel.isAccountingManager()) {
        var accountingLine = filterModel.accountingLine();
        queryParams.linkKey = accountingLine.linkKey;
        queryParams.concatValue = accountingLine.concatValue;
        queryParams.siteNumber = accountingLine.siteNumber;
      } else if (filterModel.isCardManager() || filterModel.isCardMember()) {
        var card = filterModel.card();
        queryParams.rca = card.rca;
        queryParams.bca = card.bca;
        queryParams.siteNumber = card.siteNumber;
        queryParams.cardId = card.cardId;
      }

      return queryParams;
    };

    filterModel.url = function (queryType) {
      var roleName = _.get(this.role(), 'name', '(no role)');

      return _.get(urls, [roleName, 'all', queryType]);
    };

    return filterModel;

    function defaultParamsForRole(newRole) {

      if(!newRole) {return {};}

      if (newRole.name === roles.ACCOUNTING_MANAGER || newRole.name === roles.LIMITED_ACCOUNTING_MANAGER) {
        return {
          accountingLine: _.head(UserModel.accountingLines())
        };
      } else if (newRole.name === roles.CARDMEMBER || newRole.name === roles.LIMITED_CARDMEMBER) {
        return {
          card: _.head(UserModel.cards())
        };
      } else if (newRole.name === roles.CARD_MANAGER || newRole.name === roles.LIMITED_CARD_MANAGER) {
        return {
          card: _.head(UserModel.managedCards())
        };
      } else if (newRole.name === roles.BCA_MANAGER || newRole.name === roles.LIMITED_BCA_MANAGER) {
        return {
          bca: _.head(UserModel.bcas())
        };
      } else if (newRole.name === roles.BTA_MANAGER) {
          return {
              bta: _.head(UserModel.btas())
          };
      } else {
        return {};
      }
    }

    function updateParam(model, key, value) {
      var newParams = _.clone(model.params());
      newParams[key] = value;

      model.params(newParams);
    }

    function paramGetterSetter(model, attr) {
      model[attr] = function (newVal) {
        var currentValue = _.get(model.params(), attr);

        if (arguments.length && !_.isEqual(newVal, currentValue)) {
          updateParam(model, attr, newVal);
          return newVal;
        } else {
          return currentValue;
        }
      };
    }

  });





//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/TransactionSearchModel.js
// module id = 592
// module chunks = 0